import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import Image from '../../../../../../stories/components/hotels/common/Image/Image';
import {
  FlexWrap,
  BaseColumnWrap,
  FlexItemCenter,
  ButtonBase,
  LargeSectionHeader,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const SingleRestaurentUI = styled.section(
  props => `
  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    `,
);

export const SingleFoodWrapper = styled.div(
  props => `
  padding: ${props.theme.spacing.custom(24)};
`,
);

export const RestaurantnamePara = styled.div(
  props => `
    font-size: ${props.theme.font.custom(22)};
    // margin-bottom: ${props.theme.spacing.base};
    font-weight: 600;
    padding: 1.8rem;
    background: #e8f3ff;
    border-radius: 1.2000000000000002rem;
      `,
);

export const OfferContent = styled.div(
  props => `
    display:${props.display || 'flex'};
    flex-direction: column;
      `,
);

export const FoodDiningWrapper = styled.section(
  props => `
  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    `,
);
export const DiningHeader = styled(LargeSectionHeader)(
  props => `
    border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
    border-bottom-left-radius:0;
    border-bottom-right-radius:0;
  `,
);
export const ContentWrap = styled(BaseColumnWrap)(
  props => `
   width: ${props.hasKitchenOnly ? 'fit-content' : '100%'};
   border: ${props.hasKitchenOnly ? 'unset' : '0.1rem solid #e1e7ee'};
   border-radius: 1.2000000000000002rem;
    `,
);
export const FoodRatingWrapper = styled.ul(
  props => `
    display:flex;
    align-items: center;
    padding: ${props.hasKitchenOnly ? 'unset' : props.theme.spacing.custom(18)};
    li{
        padding-right: ${props.theme.spacing.large};
        border-right: 1.7px solid rgba(10, 37, 73,0.5);
        &:last-child {
            border-right:none;
        } 
        &:nth-child(2) {
            padding-left: ${props.theme.spacing.large};
        }
        &:nth-child(3) {
            padding-left: ${props.theme.spacing.large};
        } 
    }
    `,
);
export const RatingSpan = styled.span(
  props => `
   background-color:${getRatingsColor(props.rating)};
   padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.small};
   border-radius: ${props.theme.misc.borderRadius.custom(4)};
   margin-right: ${props.theme.spacing.base};
   color: ${props.theme.colors.goWhite.base};
   font-size: ${props.theme.font.custom(18)};
    `,
);
export const RatingNumberSpan = styled.span(
  props => `
  font-weight: 600;
      `,
);
export const AmbienceSpan = styled.span(
  props => `
  font-weight: 600;
  font-size: ${props.theme.font.custom(18)};
    `,
);
